/**
 * Minimum width at which Tailwind `lg:` utilities apply (`min-width` in px).
 * Default Tailwind v3 value. If `theme.screens.lg` is customized in
 * `tailwind.config.js`, update this constant to match.
 */
export const TAILWIND_LG_MIN_WIDTH_PX = 1024;

/**
 * Media query for viewports below the `lg` breakpoint (where `lg:` is inactive).
 */
export function getMatchMediaQueryBelowTailwindLg() {
  return `(max-width: ${TAILWIND_LG_MIN_WIDTH_PX - 1}px)`;
}
